import { Injectable } from '@angular/core';
import {
    ActivatedRouteSnapshot,
    Router,
    RouterStateSnapshot,
    UrlTree,
} from '@angular/router';
import {
    KeycloakAuthGuard,
    KeycloakService,
} from '@inoventoryapps/keycloak-angular';
import { LOCALSTORAGEKEYS } from '../_constants/localStorageKeys';
import { LocalService } from '../_services/_storage/local.service';
import { UserService } from '../_services/_user/user.service';
import { SnackbarService } from '../_services/snackbar/snackbar.service';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class AuthKeycloakGuard extends KeycloakAuthGuard {
    static currentRouteRoles: string[] = [];

    constructor(
        router: Router,
        keycloakAngular: KeycloakService,
        protected _user: UserService,
        private localService: LocalService,
        private snackbarService: SnackbarService
    ) {
        super(router, keycloakAngular);
    }

    override isAccessAllowed(
        route: ActivatedRouteSnapshot,
        _state: RouterStateSnapshot
    ): Promise<boolean | UrlTree> {
        return new Promise(async (resolve, reject) => {
            if (environment.authMode === 'mock') {
                const mockUser = this.localService.get('mockUser');
                if (!mockUser) {
                    this.router.navigateByUrl('/');
                    resolve(false);
                    return;
                }
                resolve(true);
                return;
            }

            const userRoles =
                this.localService.get(LOCALSTORAGEKEYS.USERROLES) || [];
            const routeRoles = route.data['allowedRoles'] || ['all'];
            AuthKeycloakGuard.currentRouteRoles = routeRoles;
            let permission = false;

            if (!this.authenticated) {
                this.keycloakAngular
                    .login({ idpHint: '' })
                    .catch((e) => console.error(e));
                return reject(false);
            }

            if (routeRoles.includes('all')) {
                permission = true;
            } else if (Array.isArray(userRoles) && userRoles.length > 0) {
                routeRoles.forEach((role: any) => {
                    if (userRoles.includes(role)) {
                        permission = true;
                    }
                });
            }

            if (permission) {
                resolve(true);
            } else {
                this.snackbarService.errorSnackbar(
                    'You do not have permission to access this page'
                );
                this.router.navigate(['/unauthorised-access']);
                resolve(false);
            }
        });
    }
}
